export const authMapping = (responseData) => {
    const RESPONSE_DELAY_MS = 10 * 1000;
    const expirationDate = Date.now() + responseData.expires_in * 1000 - RESPONSE_DELAY_MS;

    return {
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        expirationDate,
    };
};

export const authUamMapping = (responseData, isHolder) => {
    return {
        authToken: responseData.AuthToken,
        identityKey: responseData.IdentityKey,
        uamUrl: responseData.UamUrl,
        uamApiKey: responseData.UamApiKey,
        assets: {
            assetId: responseData.Assets?.[0]?.assetId,
            isHolder: !!isHolder,
        },
    };
};

export const loginTokenMapping = (responseData) => {
    return {
        campaignUrlPersonal: responseData.CampaignUrlPersonal,
    };
};
